import { render, staticRenderFns } from "./AbnormalAmmeter.vue?vue&type=template&id=0f28a233&scoped=true&"
import script from "./AbnormalAmmeter.vue?vue&type=script&lang=js&"
export * from "./AbnormalAmmeter.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalAmmeter.vue?vue&type=style&index=0&id=0f28a233&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f28a233",
  null
  
)

export default component.exports